module.exports = __webpack_public_path__ + "static/media/gear.e3fa9dc8.svg";